import {$getSelection,$setSelection,$isRangeSelection} from 'lexical';
export function captureSelection(editor) {
  return editor.getEditorState().read(()=>{const s=$getSelection();return $isRangeSelection(s)?s.clone():null;});
}
export function restoreSelection(selection) {
  if (!selection) return;
  try { selection.anchor.getNode(); selection.focus.getNode(); $setSelection(selection.clone()); } catch { /* document was replaced */ }
}
